import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PaginationPageEvent } from '@snapon/design-system-angular';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppInfoService } from 'core/app-info/app-info.service';
import { LoadingState } from 'core/common-entities/loading-state.enum';
import { ActiveTab } from 'src/app/modules/shared/entities/active-tab.enum';
import { ImportItemsQuoteService } from 'src/app/modules/shared/import-quotes-and-orders/import-items-quote.service';
import { StorageValues } from '../../../shared/entities/storage-values.enum';
import { AdvancedSearchService } from '../../services/advanced-search.service';
import { InvoicesService } from '../services/invoices.service';

@Component({
  selector: 'app-invoices-list',
  templateUrl: './invoices-list.component.html',
  styleUrls: ['./invoices-list.component.scss'],
  standalone: false
})
export class InvoiceListComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() isOnAccountsPage;
  @Input() bpNumber;
  appStrings = this.appInfoService.appStrings;
  dateFormat = this.appInfoService.dateFormat;
  activeTab = ActiveTab;
  totalRecords = 0;
  currentPage = 0;
  pageSize = 15;
  pageOffset = 0;
  totalPages: number;
  orderList: any[];
  paginatedQuoteList: any[];
  getListMethod;
  private subs = new Subscription();
  invoiceList: any[] = [];
  isLoading = true;
  isPartialLoading = false;
  displayedColumns: string[];
  isWithRadio = false;
  customerId: string;
  templateValuesResult;
  dataLoaded = {
    templateValues: false,
    invoices: false,
  };
  invoiceKey = StorageValues.InvoiceKey;

  @ViewChild(MatSort) tableSort: MatSort;

  constructor(
    private activatedRoute: ActivatedRoute,
    private appInfoService: AppInfoService,
    private invoicesService: InvoicesService,
    private cdRef: ChangeDetectorRef,
    private advancedSearchService: AdvancedSearchService,
    private importItemsQuoteService: ImportItemsQuoteService,
  ) { }

  ngOnInit() {
    this.displayedColumns = this.isOnAccountsPage ?
      [
        'invoiceNumber',
        'invoiceDate',
        'poNumber',
        'totalAmount',
        'print',
        'view'
      ] : [
        'salesRepresentative',
        'name',
        'bpNumber',
        'invoiceNumber',
        'invoiceDate',
        'poNumber',
        'totalAmount',
        'print',
        'view'
      ];
    this.invoicesService.getTemplateValues(templateValues => {
      this.templateValuesResult = templateValues;
      this.dataLoaded.templateValues = true;
    });

    this.subs.add(this.activatedRoute.params.subscribe(() => this.customerId = this.activatedRoute.snapshot.paramMap.get('customerId')));
    this.subs.add(this.invoicesService.isProcessing$.subscribe(isLoading => {
      this.isLoading = isLoading === LoadingState.loading;
      this.isPartialLoading = isLoading === LoadingState.partiallyLoaded;
    }));
    this.subs.add(this.invoicesService.invoicesList$.subscribe(invoiceListResult => {
      this.invoiceList = invoiceListResult;
      this.dataLoaded.invoices = true;
    }));
    this.subs.add(this.invoicesService.invoicesCount$.subscribe(count => {
      this.totalRecords = count;
      this.totalPages = Math.ceil(count / this.pageSize);
    }));
    this.getListMethod = this.invoicesService.getInvoiceList.bind(this.invoicesService);
    this.isWithRadio = !!this.importItemsQuoteService.getDestinationQuoteId();
  }

  ngAfterViewChecked() {
    if (this.dataLoaded.templateValues) {
      this.cdRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  loadPage(event: PaginationPageEvent) {
    this.dataLoaded.invoices = false;
    this.currentPage = event.pageNumber;
    this.invoicesService.updatePage(event.pageNumber);
    this.pageOffset = (event.pageNumber - 1) * this.pageSize;
  }

  sortData(sort: Sort) {
    if (!sort.active) {
      return;
    } else if (!sort.direction) {
      // default sort
      sort = null;
      this.invoicesService.resetSort();
    }

    this.resetPage();
    this.invoicesService.getInvoiceList(null, sort);
  }

  resetSortIndicator(sort?: MatSort) {
    this.advancedSearchService.resetSort(this.tableSort, sort);
  }

  resetPage() {
    this.currentPage = 0;
  }

  /**
   * Prints an invoice
   * @param invoiceNumber - the invoice number
   */
  printInvoice(invoiceNumber: string) {
    this.invoicesService.printInvoice(invoiceNumber);
  }
}
